import { FileText } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * Documents on My Profile.
 *
 * There is no store for a member of staff's own documents yet — no table, no
 * upload route — so this says so plainly. The list of certificates it used to
 * show, with an upload button that saved nothing, was a sample.
 */
export function TeacherDocumentsTab() {
  return (
    <div className="card px-6 py-3 space-y-4">
      <div className="flex items-center gap-3 border-b border-line pb-3">
        <FileText className="w-6 h-6 text-indigo-600 dark:text-indigo-400" aria-hidden />
        <h3 className="text-lg font-black text-ink">My Documents</h3>
      </div>
      <EmptyState
        icon={<FileText className="h-5 w-5" />}
        title="No documents here yet"
        description="Your certificates and ID proofs are kept by the school office. Ask them if you need a copy."
      />
    </div>
  );
}
